import { faPenToSquare, faTrash } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'

export const Todo = ({task,toggleCompleted,deleteTodo,EditTodo}) => {
  return (
    <div  className='todo'>
      <span  onClick={()=>{toggleCompleted(task.id)}} className= { `${task.completed?'completed':''} text`}>{task.task+ ' '}
        </span>
        <span>
        <FontAwesomeIcon className='square' onClick={()=>EditTodo(task.id)} icon={faPenToSquare}/>
         <FontAwesomeIcon className='square' onClick={()=>deleteTodo(task.id)} icon={faTrash}/>
      </span>
    </div>
  )
}
